import { GridDataCell } from '../models/grid-data-cell.model';
export class CellEditedEventArgs {
  gridItem: GridDataCell;

  constructor(item: GridDataCell) {
    this.gridItem = item;
  }
}
